// removed by extract-text-webpack-plugin
module.exports = {"NavigationItems":"navigationItems__NavigationItems__1e5bo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/navigationItems.css
// module id = 116
// module chunks = 8